<template>
    <section id="videos" style="background-color: #273245;">
        <div class="py-5"></div>
        <v-container class="text-center">
            <h2 class="display-2 font-weight-bold py-8 white--text">VIDEOS</h2>
            <v-responsive
                v-for="video in videos"
                :key="video.id"
                class="mx-auto py-6"
                max-width="720"
            >
                <youtube :video-id="video.id" player-width="90%"></youtube>
            </v-responsive>
        </v-container>
        <div class="py-5"></div>
    </section>
</template>

<script>
    'use strict'

    import Vue from 'vue'
    import VueYouTubeEmbed from 'vue-youtube-embed'

    Vue.use(VueYouTubeEmbed)

    export default {
        name: 'Videos',
        data () {
            return {
                videos: [
                    { id: 'E6-rCN_J0oc' },
                    { id: '3c7oud2hXXg' },
                    { id: '1QxfbBPGfNI' },
                    { id: 'YK5oYQ_kPoo' },
                    { id: 'p0qCgfnHArM' },
                ]
            }
        }
    }
</script>
